// 全局配置
const config = {
  // 后端API基础地址
  baseURL: 'https://datihoutai.qinfenniao.com/prod-api',
  // 图片基础地址（用于拼接图片路径）
  imageBaseURL: 'https://datihoutai.qinfenniao.com/prod-api'
}

export default config
